//获取guid
export function getGuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

//判断是否数组
export function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

//序列化url
export function serialize(obj){
  var result = [];
  for (var k in obj) {
    if (isArray(obj[k])) {
      obj[k] = JSON.stringify(obj[k]);
    } 
    result.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]))
  }
  return result.join('&')
}

//判断是否为对象
export function isObj(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

//判断是否为空对象
export function isEmptyObject(obj) {
  for(var key in obj){
    return false
  };
  return true
};

export function getOfflineTrans() {
  const offlineMapping = {
    'zh_TW': '網絡連接錯誤，請重試!',
    'en_US': 'Network connection error, Please try again!',
    'zh_CN': '网络连接错误，请重试!'
  }
  const { I18NInfo = {} } = window.BSGlobal || {}
  const { I18NUserLang = 'zh_CN' } = I18NInfo
  return offlineMapping[I18NUserLang]
}

export function handleErrorTrans() {
  const errorMapping = {
    'zh_TW': '連接失敗',
    'zh_CN': '连接失败',
    'en_US': 'Failed to fetch'
  }
  const { I18NInfo = {} } = window.BSGlobal || {}
  const { I18NUserLang = 'zh_CN' } = I18NInfo
  return errorMapping[I18NUserLang]
}